import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { Popover } from 'react-tiny-popover';

function SuspenseItemCell(props) {
	const {
		column
	} = props;

	return (
		<span key={column.key} className={`item__cell ${column.key} suspense`} />

	);
}

export default SuspenseItemCell;
